import { Space } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';
import cn from 'classnames';

import { useAppSelector } from 'shared/lib';

import { getScenario } from 'entities/scenario';

import { BankAccountOpened } from 'features/BankAccountOpened';
import { NavigationHeader } from 'features/NavigationHeader';
import { OfferCardContainer } from 'features/OfferCardContainer';
import { PostIssuanceHelp } from 'features/PostIssuanceHelp';
import { VerificationInstructions } from 'features/VerificationInstructions';

import { selectIsCreditCard } from '../model/selector';

import styles from './OfferDisbursementScreen.module.scss';

export const OfferDisbursementScreen = () => {
  const isMobile = useIsMobile();
  const isCreditCard = useAppSelector(selectIsCreditCard);

  const scenario = useAppSelector(getScenario);

  return (
    <Space
      direction="column"
      size={24}
      className="h-mt-8 h-mb-32"
    >
      <NavigationHeader
        returnUrl={scenario?.redirectUrl}
        className="h-color-D60"
      />
      <Space
        size={isMobile ? 20 : 32}
        direction={isMobile ? 'vertical' : 'horizontal'}
      >
        <Space
          size={16}
          direction="vertical"
          className={styles.card}
        >
          <BankAccountOpened />
          <OfferCardContainer
            type={isMobile ? 'preview' : 'details'}
            detailsProps={{
              className: cn({
                [styles.creditCardMobileSummaries]: !isCreditCard,
                [styles.creditCardDesktopSummaries]: !isMobile && !isCreditCard,
              }),
            }}
          />
          <VerificationInstructions />
        </Space>

        <Space className={styles.rightPanel}>
          <PostIssuanceHelp />
        </Space>
      </Space>
    </Space>
  );
};
